import { render, staticRenderFns } from "./sidebar_menu.vue?vue&type=template&id=1120897b&scoped=true&"
import script from "./sidebar_menu.vue?vue&type=script&lang=js&"
export * from "./sidebar_menu.vue?vue&type=script&lang=js&"
import style0 from "./sidebar_menu.vue?vue&type=style&index=0&id=1120897b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1120897b",
  null
  
)

export default component.exports